import React, { useEffect, useState } from "react";
import api from "../../../Api/api";
import PropTypes from "prop-types";


function GroupSummaryModal({ groupId, onClose }) {
  const [adminName, setAdminName] = useState("");
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expenses, setExpenses] = useState([]);
  const [debts, setDebts] = useState([]);
  const [groupName, setGroupName] = useState("");



  useEffect(() => {
    const fetchData = async () => {
      try {
        const [allExpensesRes, membersRes, debtsRes, groupRes] = await Promise.all([
          api.get(`/dashboard/expenses`),
          api.get(`/groups/${groupId}/members`),
          api.get(`/groups/${groupId}/total-debts`),
          api.get(`/groups/${groupId}`)

        ]);
        setMembers(membersRes.data);
        setDebts(debtsRes.data || []);
        const groupNameFromApi = groupRes.data.name;
        setGroupName(groupNameFromApi);

        
        const groupExpenses = (allExpensesRes.data.expenses || []).filter(
          (e) => e.groupName === groupNameFromApi
        );
        setExpenses(groupExpenses);
        console.log("allExpensesRes.data:", allExpensesRes.data);
        setAdminName(groupRes.data.adminUser.name);

      } catch (err) {
        console.error("Error details:", err);
        alert("Error loading group data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [groupId]);


  //settle expense
  const handleSettle = async (expenseId) => {
    try {
      await api.post("/expense/settle", { expenseId });
      alert("✅ Expense settled!");

      // Refresh expenses
      const refreshed = await api.get("/dashboard/expenses");
      const updatedGroupExpenses = refreshed.data.filter(
        (e) => e.groupId === parseInt(groupId)
      );
      setExpenses(updatedGroupExpenses);
    } catch (err) {
      alert("❌ Failed to settle expense");
      console.error(err);
    }
  };

  const getName = (emailOrId) => {
    const member =
      typeof emailOrId === "string"
        ? members.find((m) => m.email === emailOrId)
        : members.find((m) => m.userId === emailOrId);

    return member?.name || emailOrId;
  };



  return (
    <div className="modal-backdrop">
      <div className="modal-content p-4">
        <h4 className="mb-3 text-light">Group Summary</h4>

        {loading ? (
          <p className="text-light">Loading...</p>
        ) : (
          <>
            {/* 🧾 Expenses Table */}
            <h5 className="text-light">📋 Group Expenses</h5>
            {expenses.length === 0 ? (
              <p className="text-light">No expenses for this group.</p>
            ) : (
              <table className="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>Description</th>
                    <th>Amount</th>

                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {expenses.map((e) => (
                    <tr key={e.id}>
                      <td>{e.description}</td>
                      <td>{e.totalAmount?.toFixed(2)} kr</td>
                      <td>{new Date(e.date).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* 💰 Debts Table */}
            <h5 className="mt-4 text-light">💸 Debt Summary</h5>
            {debts.length === 0 ? (
              <p className="text-light">No debts found.</p>
            ) : (
              <ul className="list-group">
                {debts.map((d, index) => (
                  <li key={d.userId} className="list-group-item">
                    {d.userName} owes {adminName} {d.totalDebt.toFixed(2)} kr
                  </li>
                ))}
              </ul>
            )}
          </>
        )}

        <button className="btn btn-secondary mt-4" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

GroupSummaryModal.propTypes = {
  groupId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default GroupSummaryModal;
